import { isTextEntry } from '~/shared/lib/isTextEntry';

import type { KeyTarget } from '../model/playerKeys';

/** Where a key was pressed, as `model/playerKeys` needs to know it. Both players ask here. */
export function keyTargetOf(target: EventTarget | null): KeyTarget {
  if (isTextEntry(target)) return 'text';
  if (target instanceof HTMLInputElement && target.type === 'range') return 'slider';
  if (target instanceof Element && target.closest('button, a, [role="radio"]') !== null) return 'control';
  return 'surface';
}
